import { create } from 'zustand';

const STORAGE_KEY = 'supplierCrm.activeOrgByUser';

const readStoredMap = (): Record<string, string> => {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    console.warn('Failed to read supplier CRM org storage', error);
    return {};
  }
};

const writeStoredMap = (map: Record<string, string>) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (error) {
    console.warn('Failed to persist supplier CRM org storage', error);
  }
};

interface SupplierCrmOrgState {
  activeOrgId: string | null;
  isBootstrapped: boolean;
  currentUserId: string | null;
  setActiveOrgId: (id: string | null) => void;
  setBootstrapped: (value: boolean) => void;
  setCurrentUserId: (userId: string | null) => void;
}

export const useSupplierCrmOrgStore = create<SupplierCrmOrgState>()((set, get) => ({
  activeOrgId: null,
  isBootstrapped: false,
  currentUserId: null,
  setActiveOrgId: (id) => {
    set({ activeOrgId: id });
    const userId = get().currentUserId;
    if (userId && typeof window !== 'undefined') {
      const map = readStoredMap();
      if (id) {
        map[userId] = id;
      } else {
        delete map[userId];
      }
      writeStoredMap(map);
    }
  },
  setBootstrapped: (value) => set({ isBootstrapped: value }),
  setCurrentUserId: (userId) => {
    set((state) => {
      let nextActiveOrgId = state.activeOrgId;
      if (userId && typeof window !== 'undefined') {
        const stored = readStoredMap()[userId];
        if (stored) {
          nextActiveOrgId = stored;
        }
      }
      return { currentUserId: userId, activeOrgId: nextActiveOrgId };
    });
  }
}));
